/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumteilnahmeworkshop12Inputs */

const de__field_datumteilnahmeworkshop12 = /** @type {(inputs: _Field_Datumteilnahmeworkshop12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Teilnahme Workshop 1`)
};

/**

* @param {_Field_Datumteilnahmeworkshop12Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumteilnahmeworkshop12 = /** @type {((inputs?: _Field_Datumteilnahmeworkshop12Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumteilnahmeworkshop12Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumteilnahmeworkshop12(inputs)
});
export { _field_datumteilnahmeworkshop12 as "_field_datumTeilnahmeWorkshop1" }